import axios from "axios";

const BASE_URL = "https://ammanat-backend.herokuapp.com";
// const BASE_URL = "http://localhost:5001";

const login = (payload) => {
  return axios.post(BASE_URL + "/authentication/login", payload);
};
const register = (payload) => {
  return axios.post(BASE_URL + "/authentication/signup", payload);
};

const createRequest = (payload) => {
  return axios.post(BASE_URL + "/user/create-request", payload);
};

const adminLogin = (payload) => {
  return axios.post(BASE_URL + "/admin/login", payload);
};
const superadminLogin = (payload) => {
  return axios.post(BASE_URL + "/superadmin/login", payload);
};
const myRequests = (id) => {
  return axios.get(BASE_URL + `/user/get-requests/${id}`);
};

const serviceProviderSignup = (payload) => {
  return axios.post(
    BASE_URL + "/authentication/serviceProvider/signup",
    payload
  );
};

const addQuery = (payload) => {
  return axios.post(BASE_URL + "/query/addQuery", payload);
};

const getQueries = () => {
  return axios.get(BASE_URL + "/query/getQueries");
};

const answerQuery = (payload) => {
  return axios.post(BASE_URL + "/query/answerQuery", payload);
};

const serviceProviderLogin = (payload) => {
  return axios.post(
    BASE_URL + "/authentication/serviceProvider/login",
    payload
  );
};

const serviceProviderInfo = (payload) => {
  return axios.post(BASE_URL + "/serviceProvider/serviceProviderInfo", payload);
};

const getAllApprovalList = () => {
  return axios.get(BASE_URL + "/admin/getAllApprovalList");
};

const adminApproveSignup = (payload) => {
  return axios.post(BASE_URL + "/admin/approveSignup", payload);
};

const adminRejectSignup = (payload) => {
  return axios.post(BASE_URL + "/admin/rejectSignup", payload);
};

const getAllRequests = () => {
  return axios.get(BASE_URL + "/serviceProvider/getAllRequests");
};

const getUserById = (id) => {
  return axios.get(BASE_URL + `/user/get-user/${id}`);
};

const createBid = (payload) => {
  return axios.post(BASE_URL + "/bids/create-bid", payload);
};

const getBids = (id) => {
  return axios.get(BASE_URL + `/bids/getBids/${id}`);
};

const userChats = (id) => {
  return axios.get(BASE_URL + `/chat/${id}`);
};

const googleLoginInfo = (payload) => {
  return axios.post(BASE_URL + `/googleLogin`, payload);
};

const getMessages = (id) => {
  return axios.get(BASE_URL + `/message/${id}`);
};

const addMessage = (payload) => {
  return axios.post(BASE_URL + "/message", payload);
};

const createChat = (payload) => {
  return axios.post(BASE_URL + "/chat", payload);
};

const getAllServiceProvidersWithCategory = (category) => {
  return axios.get(
    BASE_URL + `/serviceProvider/getAllServiceProvidersWithCategory/${category}`
  );
};

const createStripeConnectAccount = (payload) => {
  return axios.post(BASE_URL + "/payment/createAccount", payload);
};

const checkout = (payload) => {
  return axios.post(BASE_URL + "/payment/checkout", payload);
};

const tipCheckout = (payload) => {
  return axios.post(BASE_URL + "/payment/tipCheckout", payload);
};

const payment = (payload) => {
  return axios.post(BASE_URL + "/payment/transfer", payload);
};

const confirmBooking = (payload) => {
  return axios.post(BASE_URL + "/serviceProvider/confirmBooking", payload);
};

const getUserBookings = (id) => {
  return axios.get(BASE_URL + `/user/get-user-bookings/${id}`);
};

const addReview = (payload) => {
  return axios.post(BASE_URL + "/review/addReview", payload);
};

const getUserReviews = (id) => {
  return axios.get(BASE_URL + `/review/getUserReviews/${id}`);
};

const getAllUsers = () => {
  return axios.get(BASE_URL + "/user/get-all-users");
};

const updateUserInfo = (payload) => {
  return axios.post(BASE_URL + "/user/update-userInfo", payload);
};

const addCategory = (payload) => {
  return axios.post(BASE_URL + "/category/addCategory", payload);
};

const getAllCategories = () => {
  return axios.get(BASE_URL + "/category/getAllCategories");
};

const getCategoryById = (id) => {
  return axios.get(BASE_URL + `/category/getCategoryById/${id}`);
};

const updateCategory = (payload) => {
  return axios.post(BASE_URL + `/category/updateCategory`, payload);
};

const deleteCategory = (payload) => {
  return axios.post(BASE_URL + `/category/deleteCategory`, payload);
};

const getAllAdmins = () => {
  return axios.get(BASE_URL + `/admin/getAllAdmins`);
};

const deleteAdmin = (payload) => {
  return axios.post(BASE_URL + `/admin/deleteAdmin`, payload);
};

const updateAdmin = (payload) => {
  return axios.post(BASE_URL + `/admin/updateAdmin`, payload);
};

const signUpAdmin = (payload) => {
  return axios.post(BASE_URL + `/admin/signup`, payload);
};

const getAllDisputes = () => {
  return axios.get(BASE_URL + `/dispute/getAllDisputes`);
};

const addDispute = (payload) => {
  return axios.post(BASE_URL + `/dispute/addDispute`, payload);
};

const approveDispute = (payload) => {
  return axios.post(BASE_URL + `/dispute/approveDispute`, payload);
};

const rejectDispute = (payload) => {
  return axios.post(BASE_URL + `/dispute/rejectDispute`, payload);
};

const addEarning = (payload) => {
  return axios.post(BASE_URL + `/earning/addEarning`, payload);
};

const getUserEarnings = (id) => {
  return axios.get(BASE_URL + `/earning/getUserEarnings/${id}`);
};

const tipTransfer = (payload) => {
  return axios.post(BASE_URL + `/payment/tipTransfer`, payload);
};

const getUserStats = (from, to) => {
  return axios.get(BASE_URL + `/userstats/getUserStats/${from}/${to}`);
};

export {
  login,
  register,
  createRequest,
  adminLogin,
  serviceProviderSignup,
  myRequests,
  serviceProviderLogin,
  serviceProviderInfo,
  getAllApprovalList,
  adminApproveSignup,
  getAllRequests,
  getUserById,
  createBid,
  getBids,
  userChats,
  googleLoginInfo,
  getMessages,
  addMessage,
  createChat,
  adminRejectSignup,
  getAllServiceProvidersWithCategory,
  addQuery,
  getQueries,
  answerQuery,
  createStripeConnectAccount,
  checkout,
  confirmBooking,
  getUserBookings,
  addReview,
  payment,
  getAllUsers,
  updateUserInfo,
  addCategory,
  getAllCategories,
  getCategoryById,
  updateCategory,
  deleteCategory,
  getAllAdmins,
  deleteAdmin,
  updateAdmin,
  signUpAdmin,
  getAllDisputes,
  addDispute,
  approveDispute,
  rejectDispute,
  tipCheckout,
  addEarning,
  getUserEarnings,
  getUserReviews,
  tipTransfer,
  superadminLogin,
  getUserStats,
};
